import styled from 'styled-components';

export const ContainerFinish = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
`;
